// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dgmnqoshbvfzarhuauff.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRnbW5xb3NoYnZmemFyaHVhdWZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUwNzQ5OTIsImV4cCI6MjA2MDY1MDk5Mn0.Vj40__4lmW8mTL3qOIwAjRzkliEpt4NF28pJu1k0d_g";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);